<template>
  <div id="basic-card" class="home-page">
    <div class="vx-row">
      <div class="loader-block loader-block2" v-if="isLoading">
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </div>
      <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">{{ 'User actions' }}</h2>

      <vx-card>
        <div class="d-flex align-center justify-end" style="margin-bottom: 10px">
          <div class="order-filter mr-2">
            <div class="mr-1">Order by:</div>
            <v-select
              :options="[{name: 'Created at', value: 'updatedAt'}, {name: 'Data', value: 'data'}, {name: 'User', value: 'user'}]"
              v-model="orderBy.order_by"
              :clearable="false"
              label="name"
              style="width: 140px"
              :reduce="item => item.value"/>
          </div>
          <div class="order-filter mr-2">
            <div class="mr-1">Order:</div>
            <v-select
              :options="[{name: 'ASC', value: 'asc'}, {name: 'DESC', value: 'desc'}]"
              v-model="orderBy.order"
              :clearable="false"
              label="name"
              style="width: 105px"
              :reduce="item => item.value"/>
          </div>
          <vs-button class="shadow-lg" type="gradient" id="import-to-csv-btn" @click="importToCsv">Import to csv</vs-button>
        </div>
        <div class="d-flex justify-between user-actions-filters">
          <div class="d-flex w-100">
            <vs-input class=" vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                      placeholder="User email"
                      v-on:keyup="getSearchData"
                      style="margin-right: 10px;"
                      v-model="filters.userQuery"/>
          </div>
          <div class="d-flex w-100">
            <vs-input class=" vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                      placeholder="Asset id"
                      v-on:keyup="getSearchData"
                      style="margin-right: 10px;"
                      v-model="filters.assetQuery"/>
          </div>
          <div class="d-flex w-100">
            <vs-input class=" vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                      placeholder="Variation id"
                      v-on:keyup="getSearchData"
                      style="margin-right: 10px;"
                      v-model="filters.variationQuery"/>
          </div>
          <div class="d-flex w-100 vs-datepicker" style="margin-right: 10px">
            <datepicker placeholder="Date from" format="MM/dd/yyyy" class="w-100" @selected="selectFrom"></datepicker>
          </div>
          <div class="d-flex w-100 vs-datepicker">
            <datepicker v-model="filters.toQuery" placeholder="Date from" format="MM/dd/yyyy" class="w-100" @selected="selectTo"></datepicker>
          </div>
        </div>
        <div id="data-container" style="min-height: 30px; margin-top: 20px" class="relative">
          <table v-if="items && items.length > 0"
                 class="data-table mt-3">
            <thead>
            <th style="width: 25%">User</th>
            <th style="width: 8%">Asset</th>
            <th style="width: 20%">Variation</th>
            <th style="width: 15%">Created at</th>
            <th style="width: 10%">Data</th>
            </thead>
            <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <div>
                    {{item.user}}
                </div>
              </td>
              <td>
                <router-link :to="'/' + item.asset + '/edit'" v-if="item.asset">
                  {{item.asset}}
                </router-link>
              </td>
              <td>
                <div v-if="item.variations && item.variations[0]">
                  {{item.variations[0]}}
                </div>
              </td>
              <td>
                <div>
                  {{ getDateFormat(item.createdAt)}}
                </div>
              </td>
              <td>
                <div>
                  {{item.data}}
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-block">
          <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"
                         @change="handlePaginationChange"></vs-pagination>
        </div>
      </vx-card>

    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import HoverThumb from "../components/HoverThumb";
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'UserAction',
  components: {
    HoverThumb,
    vSelect,
    Datepicker
  },
  head() {
    return {
      title: {
        inner: 'AMP',
        separator: ' ',
        complement: ''
      },
      meta: [
        {hid: 'description', name: 'description', content: ''}
      ]
    }
  },
  data() {
    return {
      isLoading: false,
      debounce: false,
      isMounted: false,
      filters: {
        userQuery: '',
        assetQuery: '',
        variationQuery: '',
        fromQuery: '',
        toQuery: '',
      },
      orderBy: {
        'order': 'desc',
        'order_by': 'updatedAt'
      },
      items: [],
      currentPage: 1,
      totalItems: 0,
      itemsPerPage: 24,
      totalPages: 0,
    }
  },
  computed: {},
  mounted() {
    this.getItems();
  },
  watch: {
    filters(next, prev) {
      if (!compareObjects(next, prev)) {
        this.getItems();
      }
    },
    orderBy: {
      handler: function (newValue) {
        this.getItems();
      },
      deep: true
    },
  },
  methods: {
    handlePaginationChange() {
      if (this.isMounted) {
        this.items = [];
        this.getItems();
      }
    },
    getSearchData() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.currentPage = 1;
        this.getItems()
      }, 500)
    },
    selectFrom(d) {
      this.filters.fromQuery = d;
      this.getItems();
    },
    selectTo(d) {
      this.filters.toQuery = d;
      this.getItems();
    },
    getItems() {
      this.isLoading = true;
      let url = `/user-actions/search`;

      let qObj = {
        _limit: this.itemsPerPage,
        _start: (this.currentPage - 1) * this.itemsPerPage,
        _sort: `${this.orderBy.order_by}:${this.orderBy.order}`
      };

      qObj = Object.assign({}, qObj, this.getFilterObj());
      let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
      let q = "?" + new URLSearchParams(qArr).toString()
      url += q;

      this.$axios.get(url).then(res => {
        this.items = res.data;
        this.isLoading = false;
        if (!this.isMounted) {
          setTimeout(() => {
            this.isMounted = true;
          }, 200)
        }
      }).catch(e => {
        console.log('catch_search', e)
        this.isLoading = false;
      });

      let url2 = `/user-actions/search-count`
      delete qObj._sort;
      delete qObj._limit;
      delete qObj._start;
      qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
      q = "?" + new URLSearchParams(qArr).toString()
      url2 += q;
      this.$axios.get(url2).then(res => {
        this.totalItems = res.data;
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
      }).catch(e => {
        console.log('catch_search', e)
      })
    },
    getFilterObj() {
      let qObj = {};
      if (this.filters.userQuery) {
        qObj.user = this.filters.userQuery;
      }
      if (this.filters.assetQuery) {
        qObj.asset = this.filters.assetQuery;
      }
      if (this.filters.variationQuery) {
        qObj.variation = this.filters.variationQuery;
      }
      if (this.filters.fromQuery) {
        qObj.from = new Date(this.filters.fromQuery).setHours(0, 0, 0);
      }
      if (this.filters.toQuery) {
        qObj.to = new Date(this.filters.toQuery).setHours(23, 59, 59);
      }

      return qObj;
    },
    changePerPage(limit) {
      this.itemsPerPage = limit;
      setTimeout(() => {
        this.search()
      }, 10)
    },
    getDateFormat(date) {
      let d = new Date(date);
      return (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " +
        d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    },
    importToCsv() {
      this.$root.addLoading('#import-to-csv-btn');

      let url = `/user-actions/import-to-csv`;
      let qObj = Object.assign({}, this.getFilterObj());
      let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
      let q = "?" + new URLSearchParams(qArr).toString()
      url += q;

      this.$axios.get(url, {responseType: 'arraybuffer'}).then(res => {
        const link = document.createElement('a');
        let blob = new Blob([res.data]);
        link.href = URL.createObjectURL(blob);
        let d = new Date();
        link.download = 'user_actions' + "_" + (d.getMonth() + 1) + "_" + d.getDate() + "_" + d.getFullYear() + '.csv';
        link.click();
        URL.revokeObjectURL(link.href);

        this.$root.removeLoading('#import-to-csv-btn');
      }).catch(e => {
        console.log('catch_search', e)
        this.$root.removeLoading('#import-to-csv-btn');
      });
    }
  },

}
function compareObjects(object1, object2) {
  return (JSON.stringify(object1) === JSON.stringify(object2))
}
</script>
